import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { IApplicationState, WatrActionCreators } from '@nkr/store/index';
import { IWatrRequest } from '@nkr/models/index';
import { DevMockReceiptInput } from './constants';
import DevMockDocsOffer from './DevMockDocsOffer';

export type WatrDownloadFile = (
    docType: number,
    lookupId?: number,
    includeReceipts?: boolean
) => Promise<any>;

interface IOwnProps {
    data: IWatrRequest;
    downloadFile: WatrDownloadFile;
    receiptFileIds?: number[];
    receiptInputs?: DevMockReceiptInput[];
    includeWages?: boolean;
    includeReceipts?: boolean;
    forceWageSlots?: { forceSsn?: boolean; forceTax?: boolean; forcePaystub?: boolean };
    onComplete?: () => void;
}

interface IDispatchProps {
    uploadDevMockDocument: (args: {
        requestId: number;
        editKey: string;
        docType: number;
        lookupId: number;
        file: File;
    }) => Promise<any>;
}

type Props = IOwnProps & IDispatchProps;

const ConnectedInner: React.FC<Props> = (props) => (
    <DevMockDocsOffer
        data={props.data}
        downloadFile={(docType, lookupId) => props.downloadFile(docType, lookupId)}
        receiptFileIds={props.receiptFileIds}
        receiptInputs={props.receiptInputs}
        includeWages={props.includeWages}
        includeReceipts={props.includeReceipts}
        forceWageSlots={props.forceWageSlots}
        onComplete={props.onComplete}
        uploadDevMock={async (args) => {
            try {
                const response = await props.uploadDevMockDocument(args);
                const data = response && response.data;
                return !!(data && (data.success === true || data.Success === true));
            } catch {
                return false;
            }
        }}
    />
);

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => ({
    uploadDevMockDocument: (args) => dispatch(WatrActionCreators.uploadDevMockDocument(args) as any)
});

export default connect<{}, IDispatchProps, IOwnProps>(
    null,
    mapDispatchToProps
)(ConnectedInner) as React.ComponentType<IOwnProps>;
